export enum FSetupNodeTypes {
  Furniture = 'furniture',
  FComposition = 'fcomposition',
  // FLayout = 'flayout',
  FPolygon = 'fpolygon',
  FArea = 'farea',
  FGroup = 'fgroup',
  FOverride = 'foverride',
  Measurement = 'measurement',
  Annotation = 'annotation',
  Decoration = 'decoration',
}

export enum ChairsOrientation {
  Center = 'center',
  North = 'north',
  East = 'east',
  South = 'south',
  West = 'west',
}
